import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subject, take, takeUntil } from 'rxjs';
import { AgencyService } from 'src/app/services/agency.service';
import { AgencyCDSDialogComponent } from 'src/app/shared/components/agency-cds-dialog/agency-cds-dialog.component';

@Component({
  selector: 'ness-agency-mou-cds-form',
  templateUrl: './agency-mou-cds-form.component.html'
})
export class AgencyMouCdsFormComponent implements OnInit {

  @Input() selectedAgency: ServerModels.UpdateAgencyViewModel = null;
  @Output() closeMouCdsForm = new EventEmitter();
  @Output() onSave = new EventEmitter();

  private _unsubscribe$: Subject<void> = new Subject<void>();
  private manualDialogRef: DynamicDialogRef = null;
  CDSApprover: ServerModels.CDSUserViewModel = null;
  agencyName: string = "";
  confirmHeader: string = 'Confirm Agency Opt-out of CDS';
  private get confirmMessage(): string {
    return "You have indicated " + this.agencyName + " wants to completely opt-out of CDS. <br/><br/>" +
      "Confirming this action results in the following:<br/><br/>" +
      "1) Immediately stops all data sharing between " + this.agencyName + " and all other agencies.<br/>" +
      "2) All other agencies will be notified the data from " + this.agencyName + " is no longer being shared.<br/>" +
      "3) Resets all pending/approved CDS agreements the agency's Approver has executed with other agencies.<br/>";
  }
  
  mouForm: FormGroup;
  initialCdsValue: boolean = false;
  public optOutSubject: Subject<void> = new Subject<void>();

  constructor(
    public dialogService: DialogService,
    private agencyService: AgencyService,
    public messageService: MessageService,
    private fb: FormBuilder)
  { }

  ngOnInit(): void {
    if (this.selectedAgency) {
      this.agencyName = this.selectedAgency.ENESS_REF_Organization_ID ? this.selectedAgency.OrganizationName : this.selectedAgency.AgencyName;
      this.initialCdsValue = Object.assign({}, this.selectedAgency.CDS);
    }
    this.mouForm = this.fb.group({
      MOU: { value: false, disabled: false }, 
      CDS: { value: false, disabled: true },
    });

    this._populateFormControls();
  }

  private _populateFormControls(): void {
    if (this.selectedAgency) {
      this.mouForm.patchValue({
        MOU: this.selectedAgency.MOU,
        CDS: this.selectedAgency.CDS
      });
      this.enableChkControls();
      this.mouForm.updateValueAndValidity({ onlySelf: true });
    }
  }

  emitOptOut() {
    this.optOutSubject.next();
  }

  public onCDSApproverUpdate(data: ServerModels.CDSUserViewModel) {
      this.CDSApprover = data;
  }

  public updateCDS(checked: boolean) {
    const hasOptedOut = this.selectedAgency.CDS && !checked;

    if (checked) {
      this.mouForm.controls['MOU'].disable();      
    }
    else {
      this.mouForm.controls['MOU'].enable()
    }
    this.selectedAgency.CDS = checked;

    if (hasOptedOut) {
      this.emitOptOut();
    }
  }
  
  public saveAgency(): void {
    
    this.selectedAgency.MOU = this.mouForm.controls['MOU'].value;
    this.selectedAgency.CDS = this.mouForm.controls['CDS'].value;
    // Opt out CDS will removed CDS Approver
    if (!this.selectedAgency.CDS) {
      this.selectedAgency.CDSApproverID = null;
    }
    else {
      this.selectedAgency.CDSApproverID = this.CDSApprover ? this.CDSApprover.ApplicationUserID : this.selectedAgency.CDSApproverID;
    }

    // Opt out display confirmation dialog
    if (this.initialCdsValue && !this.selectedAgency.CDS) {
      this.displayDialog(this.selectedAgency, 'Confirm', 'Confirm')
    }
    else {
      this.submitAgencyChange();
    }        
  }

  private submitAgencyChange() {
    this.agencyService.updateAgencyCDS(this.selectedAgency).pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: (result) => {
        this.onSave.emit();
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  public closeForm() {
    this.messageService.clear();
    this.selectedAgency = null;
    this.closeMouCdsForm.emit();
  }

  private enableChkControls(): void {
    //Can check the CDS checkbox only if the MOU checkbox is checked
    //Can uncheck the MOU checkbox only if the CDS checkbox is unchecked
    if (this.selectedAgency.CDS)
      this.mouForm.controls['MOU'].disable();
    else {
      this.mouForm.controls['MOU'].enable();
    }
    if (this.selectedAgency.MOU)
      this.mouForm.controls['CDS'].enable();
    else
      this.mouForm.controls['CDS'].disable();
  }

  private displayDialog(data: any, action: string, btnDisplayName: string) {
    this.manualDialogRef = this.dialogService.open(AgencyCDSDialogComponent, {
      header: this.confirmHeader,
      dismissableMask: true,
      modal: true,
      contentStyle: {
        'overflow-y': 'auto',
        'overflow-x': 'hidden',
        'max-height': '80vh',
        'min-height': '20vh',
      },
      styleClass: 'cds-dialog w-sm-75 w-lg-50',
      baseZIndex: 1000000,
      data: {
        data: data,
        action: action,
        message: this.confirmMessage,
        dtnDisplayName: btnDisplayName
      },
    });

    this.manualDialogRef.onClose.pipe(take(1)).subscribe((data: CDSRequestViewModelWithDisplay) => {
      if (data) {
        this.submitAgencyChange();
      }        
    });
  }

}
